import $ from 'zepto';

/**
 get highest zIndex
 @method getHighestZIndex
 @private
 */
export function getHighestZIndex(targetElt, $popup, options) {
  /* bubble up through the parent elements from target to .
    find any elements that might have a z-index set that is other than "auto".
    Then add 20 to this z-index for the tooltip.
    This was done because the tooltip z-index was higher than one set for a lightbox,
    which should have hidden the tooltip.
   */
  let tooltipZIndex = 20;
  const parentElements = targetElt.parents('body');
  for (let i = 0; i < parentElements.length; i += 1) {
    const zIndex = $(parentElements[i]).css('z-index');
    if (zIndex !== 'auto') {
      tooltipZIndex += parseInt(zIndex, 10);
    }
  }

  // add a class that defines the position of the popup in relation to the target
  $popup.addClass(`xpop-position-${options.position}`);
  return tooltipZIndex;
}

export function getPopupHeightTop(top, options, targetPosTop, popupHeight) {
  if (options.position === 'top') {
    const BUFFER = 11;
    return targetPosTop - popupHeight - BUFFER;
  }
  return top;
}

export function getPointerTopPosition(options, pointerTop, popupHeight, $pointer) {
  // align the pointer
  const BORDER_BUFFER = 3;
  if (options.position === 'top') {
    return popupHeight - BORDER_BUFFER;
  }
  return Math.max(0, pointerTop - ($pointer.height() / 2));
}

/**
 Event handler for tooltip link click events.
  If the link URL is identical to the current page, then abort click action.
  This prevents scrolling to the named anchor

  @method clickEventHandler
  @public
*/
export function clickEventHandler(e) {
  const { href } = e.target;
  if (href) {
    return href.split('#')[0] !== window.location;
  }
  return true;
}

export function getZIndex(tooltipZIndex, options) {
  if (options.zIndex) {
    return tooltipZIndex + options.zIndex;
  }
  return tooltipZIndex;
}

/**
 * Return a selector string from a given DOM object (element)
 * @param domObject
 * @returns {string}
 */
export function getSelectorFromDOMObject(domObject) {
  /* This is a messy fix for when the targetSelector (which is sometimes and element
    * and sometimes a string), no longer exists, because the element was replaced.
  */
  let newSelector = '';
  const classList = domObject.className.split(/\s+/);

  newSelector += domObject.nodeName;

  // if the item has an ID, add that to the selector
  if (domObject.id) {
    newSelector += `#${domObject.id}`;
  }

  for (let i = 0; i < classList.length; i += 1) {
    if (classList[i]) {
      newSelector += `.${classList[i]}`;
    }
  }
  return newSelector;
}

export default {
  getHighestZIndex,
  getPopupHeightTop,
  getPointerTopPosition,
  getZIndex,
  clickEventHandler,
  getSelectorFromDOMObject,
};
